import FieldsPayStubEmployeeInfo from './FieldsPayStubEmployeeInfo'

export default FieldsPayStubEmployeeInfo
